export const viewConstants = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  ANY: "any"
};
